import { ReactComponent as FormatLineSpacing } from './format_line_spacing.svg';
import { ReactComponent as Copy } from './copy.svg';
import { ReactComponent as SchemaFill } from './schema_FILL1_wght400_GRAD0_opsz48 1.svg';
import { ReactComponent as TuneFill } from './tune_FILL0_wght400_GRAD0_opsz48 1.svg';
import { ReactComponent as Line } from './Rectangle 14.svg';

const Icons = {
  FormatLineSpacing,
  Copy,
  SchemaFill,
  TuneFill,
  Line,
};

export default Icons;
